import { Avatar } from '../common/avatar';
import { BreakType } from '../common/break-type';
import { ListGroupBy } from '../common/list-group-by';
import { ListItem } from '../common/list-item';
import { ListSortBy } from '../common/list-sort-by';

/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
export class Rule implements ListItem {
    public location?: Avatar;
    public schedule?: Avatar;

    public allow_mobile_ci: boolean;
    public allow_unscheduled: boolean;
    public allow_unscheduled_thresh: number;
    public allow_view_timecards: boolean;
    public allow_view_roster: boolean;
    public break_type: BreakType;
    public allow_short_paid_breaks: boolean;
    public allow_short_unpaid_breaks: boolean;
    public disclaimers: boolean;
    public max_early_ci_thresh: number;
    public ci_radius_value: number;
    public ci_radius_unit: string;
    public mobile_ci_radius: string;
    public photo_ci: boolean;
    public photo_cb: boolean;
    public photo_co: boolean;
    public mobile_photo_ci: boolean;
    public mobile_photo_cb: boolean;
    public mobile_photo_co: boolean;
    public notifications_all_schedule_managers: boolean;
    public notifications_breaks: boolean;
    public notifications_breaks_worker: boolean;
    public notifications_late_ci: boolean;
    public notifications_late_ci_thresh: number;
    public notifications_late_co: boolean;
    public notifications_late_co_thresh: number;
    public notifications_unsched_shifts: boolean;
    public snap: boolean;
    public snap_early_ci: number;
    public snap_early_co: number;
    public snap_late_ci: number;
    public snap_late_co: number;
    public max_early_ci: boolean;

    public selected: boolean = false;
    public loading: boolean = false;

    public get id(): string {
        return (
            (this.location && this.location.id) ||
            (this.schedule && this.schedule.id)
        );
    }

    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        return true;
    }

    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        return true;
    }

    getGroup(groupBy: ListGroupBy): string {
        return this.id;
    }

    /**
     * Custom valueOf allows for param based sort / comparision
     * @param ref
     * @returns {any}
     */
    valueOf(ref?: any): any {
        let res: any = this;

        if (ref === ListSortBy.NAME) {
            if (this.location) {
                res = this.location.name.toLowerCase();
            } else if (this.schedule) {
                res = this.schedule.name.toLowerCase();
            }
        }

        return res;
    }
}
